// Footer.js (Black background with gray text for better aesthetics)
import React from 'react';
import UserList from './UserList';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const companyName = 'Diamond Quality Construction L.L.C.SP';

  return (
    <footer className="bg-black text-gray-300">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <p>© {currentYear} {companyName}. All rights reserved.</p>
        </div>
      </div>
      {/* <UserList /> */}
    </footer>
  );
};

export default Footer;